import { SxProps, Theme } from "@mui/material";
import Colors from "../../theme/Colours";

export const buttonStyle: SxProps = {
  borderRadius: { xs: "5px", sm: "5px" },
  backgroundColor: Colors.primaryButtonOrange,
  alignSelf: { xs: "center", sm: "flex-end" },
  height: { xs: "30px", sm: "48px" },
  mb: { xs: "30px", sm: "0px" },
  "&:hover": {
    backgroundColor: Colors.primaryButtonOrangeHover,
  },
  padding: { xs: "18px 32px", sm: "10px 24px" },
  fontSize: { xs: "10px", sm: "16px" },
  whiteSpace: "nowrap",
};

export const buttonStyleSeller: SxProps = {
  ...buttonStyle,
  width: "300px",
  borderRadius: "4px",
};
